<template>
    <div class="ZSubSearch">
        <div class="dsh-flex-row-between-stretch">
            <dsh-select
                class="ZSubSearch-select"
                :canEdit="canEdit"
                :value="computedValue"
                :propsObj="logicPropsObj"
                @change="change"
            ></dsh-select>

            <Cascader
                v-if="propsObj._data"
                class="ZSubSearch-cascader"
                placeholder="请选择筛选参数"
                :data="propsObj._data.filter(formItem => this.fieldMap[formItem._type].canSearch)"
                :transfer="true"
                :load-data="loadData"
                @on-change="createContion"
            ></Cascader>
        </div>

        <!-- 子集类型 -->
        <dsh-formItem
            v-for="(conditionItem, conditionIndex) in computedValue.conditions"
            :key="conditionItem._id"
            :class="['ZSubSearch-controls-item']"
            :canEdit="canEdit"
            :formData="conditionItem"
            :formItem="conditionItem.formItem"
            height="80"
            @change="change(conditionItem, arguments)"
        >
            <!-- 单条关联层层筛选 -->
            <z-sub-search
                v-if="conditionItem.fieldOperator==='subSearch'"
                :canEdit="canEdit"
                :value="conditionItem"
                :propsObj="conditionItem.formItem"
                :fieldTypeMap="fieldTypeMap"
                @change="change(conditionItem, arguments)"
            ></z-sub-search>

            <!-- 动态参数选择 -->
            <dsh-select
                v-if="fieldTypeMap[conditionItem.fieldType] && fieldTypeMap[conditionItem.fieldType].length && (conditionItem.parameterType === 'dynamicText')"
                class="dsh-margin-bottom5"
                :canEdit="canEdit"
                :value="conditionItem"
                :propsObj="{
                    _name: `${conditionItem.formItem._name}的动态参数`,
                    _key: 'fieldParams',
                    _multiple: true,
                    _data: fieldTypeMap[conditionItem.fieldType]
                }"
                @change="change(conditionItem, arguments)"
            ></dsh-select>

            <!-- operator筛选类型 -->
            <div
                slot="extra"
                class="ZSubSearch-controls-extra"
            >
                <!-- 筛选参数类型 -->
                <dsh-select
                    class="ZSubSearch-controls-item-select"
                    v-if="fieldTypeMap[conditionItem.fieldType] && fieldTypeMap[conditionItem.fieldType].length"
                    :value="conditionItem"
                    :propsObj="parameterPropsObj"
                ></dsh-select>

                <dsh-dropdown
                    class="dsh-margin-right10"
                    :list="conditionItem.operators"
                    @click="$dispatchEvent(operationMap.selectOperator, $event, conditionItem)"
                >
                    <span class="ZSubSearch-controls-item-operator">
                        <span class="ZSubSearch-controls-item-operator-name dsh-ellipsis">{{ conditionItem.fieldOperatorName }}</span>
                        <Icon
                            class="dsh-margin-left5"
                            type="ios-arrow-down"
                        />
                    </span>
                </dsh-dropdown>
            </div>

            <!-- 删除 -->
            <dsh-icons
                slot="corner"
                class="ZSubSearch-controls-delete"
                :list="$getOperationList(['deleteContion'])"
                @click="$dispatchEvent(operationMap.deleteContion, conditionItem, conditionIndex, computedValue.conditions)"
            />
        </dsh-formItem>
    </div>
</template>

<script>
    import controlMixin from "../controls/controlMixin.js";
    import searchMixin from "./searchMixin.js";

    export default {
        name: "ZSubSearch",
        mixins: [controlMixin, searchMixin],
        props: {
            fieldTypeMap: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            computedValue () {
                return this.value.fieldSearch || {
                    logic: "and",
                    conditions: []
                };
            }
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                // 初始化数据
                if (this.value.fieldSearch && this.value.fieldSearch.conditions) {
                    this.value.fieldSearch.conditions.forEach(conditionItem => {
                        if (!conditionItem.operators) {
                            const fieldData = this.fieldMap[conditionItem.fieldType];
                            const operators = fieldData[this.mode === "set" ? "operatorsSet" : "operators"] || fieldData.operators;

                            conditionItem.operators = operators;
                            conditionItem.fieldOperatorName = operators.find(operatorItem => operatorItem._key === conditionItem.fieldOperator).name;
                            conditionItem.parameterType = (conditionItem.fieldParams && conditionItem.fieldParams.length) ? "dynamicText" : "fixedText";
                        }
                    });
                }

                // 初始化关联数
                if (this.propsObj._type === "reference") {
                    this.loadData({
                        _ref: this.propsObj._ref,
                        _refFields: this.propsObj._refFields
                    }, (data) => {
                        this.$set(this.propsObj, "_data", data);
                    });

                } else if (this.propsObj._type === "flatTable") {
                    this.$set(this.propsObj, "_data", this.$loopData(this.propsObj._subForm));
                }
            },
            // 添加一条数据
            createContion (value, other) {
                if (value && value.length) {
                    let newConditionItem = this.$createContion(other[value.length - 1]);
                    newConditionItem.fieldKey = value;
                    this.computedValue.conditions.push(newConditionItem);

                    this.change(newConditionItem);
                }
            },

            // 加载 reference数据
            loadData (item, callback) {
                item.loading = true;
                this.$https({
                    url: {
                        module: "sheet",
                        name: "schema"
                    },
                    params: {
                        _key: item._ref,
                        fields: item._refFields
                    },
                    callback: (res) => {
                        item.children = this.$loopData(res.screens[0].form);
                        item.loading = false;
                        callback(item.children);
                    }
                });
            },

            // 处理form 数据格式
            $loopData (data) {
                return data
                    .filter(formItem => !["tag", "summary", "editor", "referenceBy", "cascaderTable", "flatTable", "file", "cascaderTable"].includes(formItem._type))
                    .reduce((arr, formItem) => {
                        let obj = {
                            label: formItem._name,
                            value: formItem._key,
                            ...formItem
                        };
                        if (formItem._type === "reference") {
                            obj.loading = false;
                            obj.children = [];
                        }
                        arr.push(obj);
                        return arr;
                }, []);
            },

            // fieldSearch
            change () {
                this.$emit("change", this.value, this.computedValue);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/form/ZSubSearch.vue